export default "__VITE_ASSET__DR24DSFF__"